import { render, staticRenderFns } from "./PowerSockets.vue?vue&type=template&id=12cd146d"
import script from "./PowerSockets.vue?vue&type=script&lang=js"
export * from "./PowerSockets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports